import styled from "styled-components";

export const ModalContent = styled.div`
  width: 100%;
  margin: 0 auto;
  padding: 20px 0;
`;

export const ContentWrapper = styled.div`
  display: grid;
  grid-template-columns: 70% 30%;
  gap: 30px;
  margin-bottom: 30px;
  min-height: 500px;
`;

export const LeftSide = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  overflow: hidden;
  color: white;

  button {
    color: white;
    font-size: 12px;
    border-radius: 8px;

    span {
      font-size: 12px;
    }
  }

  .external-link {
    margin-top: 15px;
  }

  .documents-preview {
    overflow: hidden;

    & * {
      color: transparent;
    }
  }

  h3 {
    font-size: 18px;
    font-weight: 600;
    color: #572580;
    margin-bottom: 10px;
  }

  .documents-preview-style {
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    padding: 15px;
    background: #f9f9f9;
    max-height: 600px;
    overflow-y: auto;
  }
`;

export const RightSide = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;

  h3 {
    font-size: 18px;
    font-weight: 600;
    color: #572580;
    margin-bottom: 10px;
  }
`;

export const ProductsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 15px;
  background: #f9f9f9;
  max-height: 600px;
  overflow-y: auto;
`;

export const ProductItem = styled.div`
  padding: 10px;
  background: white;
  border-radius: 4px;
  border: 1px solid #e0e0e0;
  transition: all 0.2s;

  &:hover {
    border-color: #572580;
  }
`;

export const CheckboxWrapper = styled.div`
  display: grid;
  grid-template-columns: 20px 1fr;
  align-items: center;
  gap: 10px;

  input[type="checkbox"] {
    width: 18px;
    height: 18px;
    cursor: pointer;
  }

  label {
    font-size: 14px;
    color: #333;
    cursor: pointer;
    user-select: none;
  }
`;

export const Footer = styled.div`
  margin-top: 30px;
  padding-top: 20px;
  border-top: 1px solid #e0e0e0;

  .error-budget {
    display: flex;
    width: 100%;
    max-width: 400px;
    justify-content: center;
    margin: 0 auto;

    label {
      text-transform: none;
    }
  }
`;

export const ConfirmationText = styled.p`
  font-size: 14px;
  color: #666;
  text-align: center;
  line-height: 1.6;

  strong {
    color: #572580;
    font-weight: 600;
  }
`;
